// Automatically generated based off models.kt
@file:OptIn(ExperimentalSerializationApi::class, InternalSerializationApi::class)
@file:Suppress("UnusedImport", "UNCHECKED_CAST")

package com.ilussobsa

import com.lightningkite.*
import com.lightningkite.Length.Companion.miles
import com.lightningkite.lightningdb.*
import com.lightningkite.lightningserver.files.*
import com.lightningkite.serialization.*
import kotlin.jvm.JvmInline
import kotlin.math.roundToInt
import kotlin.time.Duration.Companion.seconds
import kotlinx.datetime.*
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseContextualSerialization
import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi
import com.lightningkite.serialization.DataClassPath
import com.lightningkite.serialization.DataClassPathSelf
import com.lightningkite.serialization.SerializableProperty
import kotlin.reflect.*
import kotlinx.serialization.*
import kotlinx.serialization.builtins.*
import kotlinx.serialization.internal.GeneratedSerializer

// Contextual types: kotlinx.datetime.Instant, com.lightningkite.UUID, com.lightningkite.lightningserver.files.ServerFile, kotlinx.datetime.LocalDate
fun prepareCompletionFields() {
    val props: Array<SerializableProperty<Completion, *>> = arrayOf(Completion_at, Completion_bids, Completion_participants, Completion_sold, Completion_price, Completion_bidPrice, Completion_winner, Completion_startingBid)
    Completion.serializer().properties { props }
}
val <K> DataClassPath<K, Completion>.at: DataClassPath<K, Instant> get() = this[Completion_at]
val <K> DataClassPath<K, Completion>.bids: DataClassPath<K, Int> get() = this[Completion_bids]
val <K> DataClassPath<K, Completion>.participants: DataClassPath<K, Int> get() = this[Completion_participants]
val <K> DataClassPath<K, Completion>.sold: DataClassPath<K, Boolean> get() = this[Completion_sold]
val <K> DataClassPath<K, Completion>.price: DataClassPath<K, PriceInDollars> get() = this[Completion_price]
val <K> DataClassPath<K, Completion>.bidPrice: DataClassPath<K, PriceInDollars> get() = this[Completion_bidPrice]
val <K> DataClassPath<K, Completion>.winner: DataClassPath<K, UUID?> get() = this[Completion_winner]
val <K> DataClassPath<K, Completion>.startingBid: DataClassPath<K, PriceInDollars?> get() = this[Completion_startingBid]
inline val Completion.Companion.path: DataClassPath<Completion, Completion> get() = path<Completion>()


object Completion_at: SerializableProperty<Completion, Instant> {
    override val name: String by lazy { Completion.serializer().descriptor.getElementName(0) }
    override fun get(receiver: Completion): Instant = receiver.at
    override fun setCopy(receiver: Completion, value: Instant) = receiver.copy(at = value)
    override val serializer: KSerializer<Instant> by lazy { (Completion.serializer() as GeneratedSerializer<*>).childSerializers()[0] as KSerializer<Instant> }
    override val annotations: List<Annotation> by lazy { Completion.serializer().descriptor.getElementAnnotations(0) }
    override val default: Instant = now()
    override val defaultCode: String? = "now()" 
}
object Completion_bids: SerializableProperty<Completion, Int> {
    override val name: String by lazy { Completion.serializer().descriptor.getElementName(1) }
    override fun get(receiver: Completion): Int = receiver.bids
    override fun setCopy(receiver: Completion, value: Int) = receiver.copy(bids = value)
    override val serializer: KSerializer<Int> by lazy { (Completion.serializer() as GeneratedSerializer<*>).childSerializers()[1] as KSerializer<Int> }
    override val annotations: List<Annotation> by lazy { Completion.serializer().descriptor.getElementAnnotations(1) }
}
object Completion_participants: SerializableProperty<Completion, Int> {
    override val name: String by lazy { Completion.serializer().descriptor.getElementName(2) }
    override fun get(receiver: Completion): Int = receiver.participants
    override fun setCopy(receiver: Completion, value: Int) = receiver.copy(participants = value)
    override val serializer: KSerializer<Int> by lazy { (Completion.serializer() as GeneratedSerializer<*>).childSerializers()[2] as KSerializer<Int> }
    override val annotations: List<Annotation> by lazy { Completion.serializer().descriptor.getElementAnnotations(2) }
}
object Completion_sold: SerializableProperty<Completion, Boolean> {
    override val name: String by lazy { Completion.serializer().descriptor.getElementName(3) }
    override fun get(receiver: Completion): Boolean = receiver.sold
    override fun setCopy(receiver: Completion, value: Boolean) = receiver.copy(sold = value)
    override val serializer: KSerializer<Boolean> by lazy { (Completion.serializer() as GeneratedSerializer<*>).childSerializers()[3] as KSerializer<Boolean> }
    override val annotations: List<Annotation> by lazy { Completion.serializer().descriptor.getElementAnnotations(3) }
}
object Completion_price: SerializableProperty<Completion, PriceInDollars> {
    override val name: String by lazy { Completion.serializer().descriptor.getElementName(4) }
    override fun get(receiver: Completion): PriceInDollars = receiver.price
    override fun setCopy(receiver: Completion, value: PriceInDollars) = receiver.copy(price = value)
    override val serializer: KSerializer<PriceInDollars> by lazy { (Completion.serializer() as GeneratedSerializer<*>).childSerializers()[4] as KSerializer<PriceInDollars> }
    override val annotations: List<Annotation> by lazy { Completion.serializer().descriptor.getElementAnnotations(4) }
}
object Completion_bidPrice: SerializableProperty<Completion, PriceInDollars> {
    override val name: String by lazy { Completion.serializer().descriptor.getElementName(5) }
    override fun get(receiver: Completion): PriceInDollars = receiver.bidPrice
    override fun setCopy(receiver: Completion, value: PriceInDollars) = receiver.copy(bidPrice = value)
    override val serializer: KSerializer<PriceInDollars> by lazy { (Completion.serializer() as GeneratedSerializer<*>).childSerializers()[5] as KSerializer<PriceInDollars> }
    override val annotations: List<Annotation> by lazy { Completion.serializer().descriptor.getElementAnnotations(5) }
}
object Completion_winner: SerializableProperty<Completion, UUID?> {
    override val name: String by lazy { Completion.serializer().descriptor.getElementName(6) }
    override fun get(receiver: Completion): UUID? = receiver.winner
    override fun setCopy(receiver: Completion, value: UUID?) = receiver.copy(winner = value)
    override val serializer: KSerializer<UUID?> by lazy { (Completion.serializer() as GeneratedSerializer<*>).childSerializers()[6] as KSerializer<UUID?> }
    override val annotations: List<Annotation> by lazy { Completion.serializer().descriptor.getElementAnnotations(6) }
    override val default: UUID? = null
    override val defaultCode: String? = "null" 
}
object Completion_startingBid: SerializableProperty<Completion, PriceInDollars?> {
    override val name: String by lazy { Completion.serializer().descriptor.getElementName(7) }
    override fun get(receiver: Completion): PriceInDollars? = receiver.startingBid
    override fun setCopy(receiver: Completion, value: PriceInDollars?) = receiver.copy(startingBid = value)
    override val serializer: KSerializer<PriceInDollars?> by lazy { (Completion.serializer() as GeneratedSerializer<*>).childSerializers()[7] as KSerializer<PriceInDollars?> }
    override val annotations: List<Annotation> by lazy { Completion.serializer().descriptor.getElementAnnotations(7) }
    override val default: PriceInDollars? = null
    override val defaultCode: String? = "null" 
}
